import { Box } from "@acko-tech/building-blocks.ui.common";
import { Text as BaseText } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 0px;
  width: 100%;
  ${(props: any) => props.styles}
`;

export const TextRow = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Text = styled(BaseText)`
  color: var(--text-secondary-n-400, #5B5675);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; 
  margin: 0;
`;

export const Subtext = styled(BaseText)`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.1px;
  margin: 0;
  margin-top: 4px;
`;

export const EditButton = styled.button`
  color: var(--button-hyperlink-b-300, #1B73E8);
  text-align: right;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
  
  &:active {
    opacity: 0.6;
  }
`;

